import {initialState} from './state.js';
import {resetPassword, setPassword, validateCode} from "../repository/PasswordRepository";
import {
    SEND_CODE,
    VALIDATE_CODE,
    SET_PASSWORD,
    RESET_STATE,
} from './types';

export default {

    [SEND_CODE] ({state}) {
        if (! state.email) {
            throw new Error('Email is empty!');
        }

        return resetPassword(state.email);
    },

    [VALIDATE_CODE] ({state}) {
        if (! state.email || ! state.code) {
            return Promise.reject(new Error('Email or code is empty!'));
        }

        return validateCode(state.email, state.code).then(({data}) => {
            state.user = data;
        });
    },

    [SET_PASSWORD] ({state}, password) {
        if (! state.email || ! state.code) {
            return Promise.reject(new Error('Email or code is empty!'));
        }

        return setPassword(state.email, state.code, password);
    },

    [RESET_STATE] ({state}) {
        Object.assign(state, initialState());
    }
};
